import { Flex, Text } from '@radix-ui/themes'
import { DataList } from '@radix-ui/themes'
import { formatLitres } from './format'
import { LeakV0DetailRow, LeakV0PanelBox } from './LeakV0PanelBox'
import type { StationLeakV0Status } from './summary'

interface LeakV0ConfigPanelProps {
  status: StationLeakV0Status
}

const LeakProviderValue = ({ leakProvider }: Pick<StationLeakV0Status, 'leakProvider'>) => (
  <Flex direction="column" gap="1">
    <Text>{leakProvider}</Text>
    <Text size="1" color="gray">
      Fleet-wide default, not a per-station value yet.
    </Text>
  </Flex>
)

export const LeakV0ConfigPanel = ({ status }: LeakV0ConfigPanelProps) => (
  <LeakV0PanelBox title="Detector config">
    <DataList.Root size="1" orientation="vertical">
      <LeakV0DetailRow label="Leak provider" value={<LeakProviderValue leakProvider={status.leakProvider} />} />
      <LeakV0DetailRow label="Floor reference" value={status.floorReference} />
      <LeakV0DetailRow
        label="Start flow"
        value={status.startFlowLPerHour === null ? null : `${formatLitres(status.startFlowLPerHour)}/h`}
      />
      <LeakV0DetailRow label="Algo version" value={status.algoVersion} />
      <LeakV0DetailRow label="Notes" value={status.notes} />
    </DataList.Root>
  </LeakV0PanelBox>
)
